var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-notification',{attrs:{"has-icon":true,"icon":"info","closable":false}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('compCarbonFormsCommutesHelpManual.text-1'))}})]),_c('help-data')],1)}
var staticRenderFns = []

export { render, staticRenderFns }